import { toast } from 'react-toastify';

const success = (str: string, opt = {}) => toast.success(str, opt);

const error = (str: string, opt = {}) => toast.error(str, opt);

const info = (str: string, opt = {}) => toast.info(str, opt);

const update = (str: string | number, opt = {}) => toast.update(str, opt);

const remove = () => toast.dismiss();

const snackbar = { success, error, info, remove, update };

export default snackbar;
